// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const Environment = {
  production: true,
  firebase : {
    apiKey: "AIzaSyDjh5ypU1hcSoIjBfR0lg9zIPDQvpNZ7yU",
    authDomain: "bleaf-9753d.firebaseapp.com",
    projectId: "bleaf-9753d",
    storageBucket: "bleaf-9753d.appspot.com",
    messagingSenderId: "700045098725",
    appId: "1:700045098725:web:2a79545800232235941e0c",
    vapidKey: "BEaDAvNRgCkCxAJbvCE5FWMQuIyd_VjbqILRx7kDJEnTuFF2O13Lwi4pR4Vh-INIoIrDEA_Tus6UH3qr17BqEeE"
  },

  SLINGSHOT_PREFIX : '/alfresco/s/slingshot/',
  API_PREFIX : '/alfresco/s/api/',
  BLEAF_PREFIX : '/alfresco/s/bgear/'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
